<template>
    <div id="app">
        <Header/>
        <Main/>

        <ModalSearch/>
    </div>
</template>

<script>
import Header from "./components/Header";
import Main from "./components/Main";
import ModalSearch from "./components/ModalSearch";

export default {
    components: {ModalSearch, Main, Header},
    mounted() {
    const btnPreloaderSkip = document.querySelector('#preloader .preloader-skip');
    btnPreloaderSkip.style.display = 'block';
    },
}

</script>

<style lang="scss">
    #app {
        position: relative;
    }
    
</style>
